<template>
  <div>
    <b-alert
      :variant="userNotification.type.toLowerCase()"
      :show="true"
      style="border-radius:0px"
      @dismissed="del"
      :dismissible="dismissible"
    >
      <b-row align-v="center">
        <b-col cols="auto" class="ml-5 mr-4">
          <i :class="userNotification.icon" style="font-size: 2.3rem"></i>
        </b-col>
        <b-col cols="auto">
          {{ userNotification.created | moment("MM/DD/YYYY") }}<br />
          <small>
            {{ userNotification.created | moment("hh:mm A") }}
          </small>
        </b-col>
        <b-col class="ml-2 mr-2">
          <div v-if="userNotification.fullyQualifiedUrl">
            <b>{{ userNotification.title }}</b>
          </div>
          <div v-else>
            <b>{{ userNotification.title }}</b>
          </div>

          {{ userNotification.text }}
        </b-col>
        <b-col cols="auto" class="text-right alert-button">
          <b-button
            :href="userNotification.fullyQualifiedUrl"
            target="_blank"
            class="shadow-none"
            variant="primary"
            >Read More</b-button
          >
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
export default {
  created() {
    this.dismissible = this.showDelete;
  },
  data() {
    return {
      dismissible: true,
    };
  },
  methods: {
    del() {
      this.$emit("delete", this.userNotification);
    },
  },
  props: { showDelete: null, userNotification: null },
};
</script>

<style scoped>
.alert-button .btn {
  color: #fff;
}
</style>
